import { TableCell } from '@mui/material';

export default function DownloadsCell({ downloads }) {
  return (
    <TableCell>
      {Array.isArray(downloads) && downloads.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {downloads.map((d, idx) => (
            <a
              key={idx}
              href={d.url}
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: 'underline',
                color: 'inherit',
                cursor: 'pointer',
                lineHeight: 1.4,
              }}
              title={d.url}
            >
              {d.title}
            </a>
          ))}
        </div>
      ) : (
        <span>-</span>
      )}
    </TableCell>
  );
}